// Do not load M-related code for O
export default function AdvertisedProducts() {
  return null;
}
